<template>
	<button
		type='submit'
		class="site_button"
		:class="[theme, type, (is_hovered ? 'is_hovered' : null)]"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="site_button"
	>

		<span class="hover_arrow">&rarr;</span>

		<span v-html="button_label ? button_label : parsedLink.title"></span>

		<span class="arrow">&rarr;</span>

	</button>
</template>

<script>
export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
		};
	},

	props: {
		link: {},
		label: {},
		is_hovered: {
			type: Boolean,
			default: false,
		},
		target: {},
		theme: {
			default: 'light',
		},
		type: {
			default: 'normal',
		},
	},

	computed: {

	},

	watch: {

	},

	methods: {

	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button {
	appearance: none;
	display: inline-flex !important;
	padding: 16px 24px 14px !important;
	border-radius: 30px !important;
	text-decoration: none;
	/* height: 60px; */
	display: inline-flex;
	justify-content: flex-start;
	/* align-items: center; */
	transition: 0.2s ease all;
	color: var(--duco-blue) !important;
	border: 1px solid var(--light-grey) !important;
	overflow: hidden;
	min-width: 280px !important;
	position: relative;
	background: transparent !important;
	box-shadow: none !important;

	.stay_in_touch & {
		color: var(--light-grey) !important;
	}

	@media (max-width: $laptop) {
		min-width: auto;
	}

	&.dark {
		color: var(--light-grey);
	}

	@media (hover) {
		&:hover {
			background: var(--duco-blue) !important;
			transition: 0.2s ease all;
			cursor: pointer;

			span {
				color: var(--light-grey) !important;
			}

			.arrow {
				transform: translateX(50px);
				opacity: 0;
				pointer-events: none;
			}

			.hover_arrow {
				transform: translateX(50px);
				opacity: 1;
				pointer-events: none;
			}
		}
	}

	&[is_hovered='true'], &.is_hovered {
		background: var(--duco-blue);
		transition: 0.2s ease all;
		cursor: pointer;

		span {
			color: var(--light-grey);
		}

		.arrow {
			transform: translateX(50px);
			opacity: 0;
			pointer-events: none;
		}

		.hover_arrow {
			transform: translateX(50px);
			opacity: 1;
			pointer-events: none;
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal normal 16px/16px var(--primary-font-family);
		transition: 0.2s ease all;
		margin-right: 0;
		position: relative;
		z-index: 10;
		margin-left: 20px;
	}

	.arrow {
		position: relative;
		margin-left: 10px;
	}

	.hover_arrow {
		position: absolute;
		left: -50px;
		opacity: 0;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SubmitButton.vue